import React from 'react';
import { remCss } from 'src/helpers';

const LockIcon = React.memo(({ width = 50, height = 80, viewBox = '0 0 50 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <g id='Group_3939' data-name='Group 3939' transform='translate(-376 -780)'>
      <rect
        id='Rectangle_1389'
        data-name='Rectangle 1389'
        width='50'
        height='80'
        rx='25'
        transform='translate(376 780)'
        fill='#fff'
        opacity='0.2'
      />
      <path
        id='lock'
        d='M17,2.8a5.6,5.6,0,0,1,5.6,5.6V19.6H11.4V8.4A5.6,5.6,0,0,1,17,2.8Zm8.4,16.8V8.4a8.4,8.4,0,0,0-16.8,0V19.6A5.6,5.6,0,0,0,3,25.2v14a5.6,5.6,0,0,0,5.6,5.6H25.4A5.6,5.6,0,0,0,31,39.2v-14A5.6,5.6,0,0,0,25.4,19.6ZM8.6,22.4H25.4a2.8,2.8,0,0,1,2.8,2.8v14A2.8,2.8,0,0,1,25.4,42H8.6a2.8,2.8,0,0,1-2.8-2.8v-14A2.8,2.8,0,0,1,8.6,22.4Z'
        transform='translate(385 798)'
        fill='#fff'
      />
    </g>
  </svg>
));
LockIcon.displayName = 'LockIcon';

export default LockIcon;
